import React from 'react';
import PropTypes from 'prop-types';

import { SpinnerStyled } from './Spinner.styled';

export const spinnerSize = {
  SMALL: 'small',
  LARGE: 'large',
};
/**
 * **Spinner** component is used to notify users that an action is being processed.
 */

export default function Spinner(props) {
  return <SpinnerStyled {...props} />;
}

Spinner.defaultProps = {
  size: spinnerSize.LARGE,
  autoColor: false,
  isDark: false,
};

Spinner.propTypes = {
  className: PropTypes.string,
  /**
   * String with value and units
   */
  margin: PropTypes.string,
  /**
   * The spinner color will depend on its parent
   */
  autoColor: PropTypes.bool,
  /**
   * Large or small
   */
  size: PropTypes.oneOf(Object.values(spinnerSize)),
  /**
   * When it is on it inverts the main colors
   */
  isDark: PropTypes.bool,
};
